// Created on 2021-04-12
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-12
const moment = require('moment')

const util = {
  removeQ: function(input) {
    if (typeof input === 'string' || input instanceof String) {
      return input.substring(input[0] === '"' ? 1 : 0, input.length > 1 && input[input.length - 1] === '"' ? input.length - 1 : input.length).trim()
    } else {
      return input
    }
  },
  getLastSyncText: function (date) {
    if (!date) return null
    const today = new Date().setHours(0, 0, 0, 0)
    if (Number(date) > today) {
      const tmpDate = new Date(date)
      return moment(tmpDate).format('HH:mm')
    } else {
      const now = Date.now()
      if ((date) < (today - 86400000)) {
        return 'pred ' + (Math.floor((now - date) / 86400000)) + 1 + ' dňami'
      } else
        return 'včera'
    }
  }
}

export default util